(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./pages/_app.js + 15 modules
var _app = __webpack_require__(5585);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./constants/SpaceResponsive.js
var SpaceResponsive = __webpack_require__(4613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/view/my-stickers/Welcome.js







var Welcome = function Welcome(props) {
  var welcome = props.welcome,
      setWelcome = props.setWelcome;
  var welcomeRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WelcomeWrapper, {
    onClick: function onClick(e) {
      if (!welcomeRef.current.contains(e.target)) {
        setWelcome(false);
        router.push("/my-stickers");
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(WelcomeBox, {
      ref: welcomeRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpaceResponsive/* default */.Z, {
        height: 60
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "https://img.stipop.io/image/account/welcome-image.png",
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpaceResponsive/* default */.Z, {
        height: 30
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        style: {
          height: '43px',
          fontSize: '30px',
          fontWeight: '600'
        },
        children: "Welcome to Stipop!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpaceResponsive/* default */.Z, {
        height: 35
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Desc, {
        children: ["Your membership account is now active. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Go to the ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            fontWeight: '600'
          },
          children: "Apps"
        }), " page and start by setting up Stipop for Chrome and iMessage."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpaceResponsive/* default */.Z, {
        height: 53
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SetUpButton, {
        onClick: function onClick() {
          router.push("/apps");
        },
        children: "Set up Chrome and iMessage"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpaceResponsive/* default */.Z, {
        height: 16.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close, {
        onClick: function onClick() {
          router.push("/my-stickers");
        },
        children: "I'll check it later"
      })]
    })
  });
};

/* harmony default export */ var my_stickers_Welcome = (Welcome);
var WelcomeWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Welcome__WelcomeWrapper",
  componentId: "sc-nyv2e1-0"
})(["width:100vw;height:100vw;background-color:rgba(164,164,164,0.6);position:fixed;top:0;left:0;"]);
var WelcomeBox = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Welcome__WelcomeBox",
  componentId: "sc-nyv2e1-1"
})(["width:566px;height:603px;background-color:#fff;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);border:1px solid #e5eaf2;border-radius:34px;box-shadow:0 17px 28px 1px rgba(0,0,0,0.12);display:flex;flex-direction:column;align-items:center;img{width:164px;height:157px;padding-right:20px;}"]);
var Title = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Welcome__Title",
  componentId: "sc-nyv2e1-2"
})(["font-family:Poppins,sans-serif;height:38px;font-size:28px;font-weight:600;line-height:1.32;letter-spacing:0.22px;color:#0e0f19;"]);
var Desc = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Welcome__Desc",
  componentId: "sc-nyv2e1-3"
})(["width:434px;height:72px;font-family:Poppins,sans-serif;font-size:18px;line-height:1.33;color:#0e0f19;text-align:center;"]);
var SetUpButton = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Welcome__SetUpButton",
  componentId: "sc-nyv2e1-4"
})(["width:358px;height:54px;border-radius:14px;background-color:#ff4500;border:none;color:#fff;font-size:18px;font-family:Poppins,sans-serif;&:hover{cursor:pointer;}"]);
var Close = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Welcome__Close",
  componentId: "sc-nyv2e1-5"
})(["height:24px;font-family:Poppins,sans-serif;font-size:14px;line-height:1.71;color:#838383;cursor:pointer;&:hover{color:#ff4500;}"]);
// EXTERNAL MODULE: ./common/common.js
var common = __webpack_require__(3095);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
;// CONCATENATED MODULE: ./pages/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var index = function index() {
  var router = (0,next_router.useRouter)();
  var lang = (0,react.useContext)(_app.UserLanguageContext);
  var cookies = new es6/* default */.Z();

  var _useState = (0,react.useState)(false),
      welcome = _useState[0],
      setWelcome = _useState[1];

  var _useState2 = (0,react.useState)(false),
      tracking = _useState2[0],
      setTracking = _useState2[1];

  var token = cookies.get('stipop-token', common/* COOKIE_OPTION */.pN);
  (0,react.useEffect)(function () {
    if (token) {
      axios_default().get("".concat(common/* API_HOST */.H, "/v4/mypage"), {
        headers: {
          // apikey: process.env.API_KEY,
          token: token
        }
      }).then(function (_ref) {
        var data = _ref.data;
        mixpanel_cjs_default().identify(data.body.userInfo.userId);
        localStorage.setItem('stipop-account', JSON.stringify(_objectSpread(_objectSpread({}, data.body.userInfo), {}, {
          token: token
        })));
        setTracking(true);
      });
    } else {
      var token2 = cookies.get('stipop-token', common/* COOKIE_OPTION */.pN);

      if (!token2) {
        localStorage.removeItem('stipop-account');
        router.push("".concat(common/* STIPOP_DOMAIN */.XY, "/signin"));
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (tracking) {
      axios_default().put("".concat(common/* API_HOST */.H, "/v4/mypage/popup/account"), '', {
        headers: {
          // apikey: process.env.API_KEY,
          token: token
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.body === true) {
          setWelcome(true);
        } else {
          if (localStorage.getItem('stipop-account')) {
            router.push("/my-stickers");
          }
        }
      });
    }
  }, [tracking]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: welcome && /*#__PURE__*/(0,jsx_runtime.jsx)(my_stickers_Welcome, {
      welcome: welcome,
      setWelcome: setWelcome
    })
  });
};

index.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(context) {
    var meta;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            meta = {
              title: "Stipop | A complete sticker API and SDK for all apps",
              description: 'Strenghen community and increase retention with Stipop sticker API and SDK solution. Add 150,000+ unique stickers within a day with pre-built UI components for sticker search and store. Get started for free today.',
              url: "https://account.stipop.com"
            };
            return _context.abrupt("return", {
              meta: meta
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ var pages = (index);

/***/ }),

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(905);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);